<app-label
  class="text-navy-90"
  [icon]="'monitored'"
  [name]="buildTranslationKey('name') | translate"
  [isHoverable]="false"
  [ngbTooltip]="buildTranslationKey('tooltip') | translate"
  [tooltipClass]="'default-tooltip max-w-10/12'"
  [placement]="tooltipPlacement"
  [triggers]="tooltipTriggers"
  (click)="isMobile && $event.stopPropagation()"
></app-label>
